<script>
import api from '@utils/api'
import { sortBy, uniq } from 'lodash'
import { getGoodsGroup } from '@utils/goods-group'

export default {
  name: 'SerialSearchSelect',
  props: {
    label: {
      type: String,
      default: 'label__serial',
    },
    inMyOrganization: {
      type: Boolean,
      default: false,
    },
    notInMyOrganization: {
      type: Boolean,
      default: false,
    },
    value: {
      type: String,
      default: null,
    },
    deviceType: {
      type: Number,
      default: null,
    },
  },
  data() {
    return {
      loading: false,
      serial: this.value,
      serialList: [],
      search: null,
      rules: {
        isRequired: [x => !!x || this.$t('validation__is_required')],
      },
      myOrganizations: null,
      responseData: null,
    }
  },
  computed: {
    goods() {
      return this.$store.getters['data/getDictionary']('goods')
    },
  },
  watch: {
    value() {
      this.serial = this.value
      this.search = this.value
    },
    search() {
      this.searchSerial()
    },
    serial(value) {
      if (value) this.$emit('selected', value)
    },
    deviceType: {
      handler(val) {
        this.deviceType = val
        this.serialList = this.setSerialList()
      },
      deep: true,
    },
  },
  created() {
    if (this.notInMyOrganization || this.inMyOrganization) {
      this.getMyOrganizations()
    }
  },
  methods: {
    getMyOrganizations() {
      // return api.getItems('myorganization').then(response => {
      //   this.myOrganizations = response.map(elem => elem.id)
      // })
      // TODO get default organization from store
      this.myOrganizations = [1]
    },
    searchSerial() {
      this.loading = true
      api
        .getItems('warehouse', {
          filter_serial_value: this.search,
          filter_serial_comparison: 'LIKE',
          filter_writeoff_value: 'false',
          filter_writeoff_comparison: 'EQ',
          filter_quantity_value: '0',
          filter_quantity_comparison: 'NE',
          size: 10000,
          sort_property: 'createTime',
          sort_direction: 'DESC',
          page: 1,
        })
        .then(response => {
          this.responseData = response.content
          this.serialList = this.setSerialList()
        })
        .catch(() => {})
        .then(() => {
          this.loading = false
        })
    },
    getDeviceType(sourceDeviceType) {
      if (sourceDeviceType === 5) {
        return 2
      }
      return sourceDeviceType
    },
    setSerialList() {
      if (this.responseData) {
        const uniqSerials = uniq(
          this.responseData.map(elem => elem.serial || '')
        )
        const result = []
        if (this.inMyOrganization) {
          uniqSerials.forEach(serial => {
            if (serial) {
              const item = this.responseData.find(
                elem =>
                  elem.serial === serial &&
                  getGoodsGroup(this.goods, elem.goods) === 2
              )
              if (!item) {
                return
              }
              if (this.myOrganizations.includes(item.organisation)) {
                result.push(item)
              }
            }
          })
          return sortBy(uniq(result.map(e => e.serial)))
        }
        if (this.notInMyOrganization) {
          uniqSerials.forEach(serial => {
            if (serial) {
              const item = this.responseData.find(
                elem =>
                  elem.serial === serial &&
                  getGoodsGroup(this.goods, elem.goods) !== 2 &&
                  getGoodsGroup(this.goods, elem.goods) !== 3
              )
              if (!item) {
                return
              }
              if (!this.myOrganizations.includes(item.organisation)) {
                result.push(item)
              }
            }
          })
          return sortBy(uniq(result.map(e => e.serial)))
        }
        if (this.deviceType) {
          uniqSerials.forEach(serial => {
            const item = this.responseData.find(
              elem =>
                elem.serial === serial &&
                this.getDeviceType(getGoodsGroup(this.goods, elem.goods)) ===
                  this.deviceType
            )
            if (item) {
              result.push(item)
            }
          })
          return sortBy(uniq(result.map(e => e.serial)))
        }
        return sortBy(uniqSerials)
      }
    },
  },
}
</script>

<template>
  <v-select
    :label="$t(label)"
    v-model="serial"
    :loading="loading"
    :items="serialList"
    :search-input.sync="search"
    :rules="rules.isRequired"
    autocomplete
    required
  />
</template>
